<template>
	<van-dialog 
		v-model="open" 
		:title="title" 
		show-cancel-button
		:confirm-button-text="confirmButtonText"
		confirm-button-color="rgb(71, 118, 227)"
		@cancel="handleCancel"
		@confirm="handleConfirm"
	></van-dialog>
</template>

<script>
import { Dialog } from "vant";
	export default {
    components:{
      [Dialog.Component.name]: Dialog.Component
    },
		data(){
			return {
				open:false,
				title:"标题",
				cancel:null,
				confirm:null,
				confirmButtonText:"确认",
				initialData:{}
			}
		},
		mounted(){
			this.initialData = this.deepClone(this.$data);
		},
		methods:{
			show(options){
				this.reset();
				this.init(options);
				this.open = true;
			},
			init(options){
				Object.keys(options).map(key => {
					if(this.$data.hasOwnProperty(key)) this[key] =  ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(options[key])) ? this.deepClone(options[key]) : options[key];
				})
			},
			reset(){
				Object.keys(this.initialData).map(key => {
					if(key === "initialData") return false;
					this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(this.initialData[key])) ? this.deepClone(this.initialData[key]) : this.initialData[key];
				})
			},
			handleCancel(){
				if(this.cancel) this.cancel();
			},
			handleConfirm(){
				if(this.confirm) this.confirm();
			},
		}
	}
</script>

<style scoped lang="scss">
	.popup-header {
		display: flex;
		justify-content: space-between;
		padding: 16rpx 24rpx;
		.title {
			font-size: 32rpx;
			line-height: 64rpx;
		}
	}
	.popup-body {
        
	}
	.popup-footer {
		padding: 80rpx 64rpx;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>